"use client"

import { useMemo, useEffect } from 'react'
import ResizeObserver from 'resize-observer-polyfill';
import { useAppDispatch } from '../../lib/redux/hooks';
import { globalActions } from '@/lib/redux/features/global/reduce';

let timeoutResize: any = null

export const useDeviceResize = () => {
  const dispatch = useAppDispatch()

  const ro = useMemo(() => new ResizeObserver((entries) => {
    if (entries.length > 0) {
      const onResize = () => {
        const realWidth = window.innerWidth
        if (realWidth < 992) {
          dispatch(globalActions.setIsDesktop(false))
        } else {
          dispatch(globalActions.setIsDesktop(true))
        }
      }

      if (timeoutResize) clearTimeout(timeoutResize);
      timeoutResize = setTimeout(onResize, 500)
    }
  }), []);

  useEffect(() => {
    ro.observe(document.body)
    return () => {
      ro.unobserve(document.body)
    }
  }, [])
}